/* ============================================================================
   compraloy-cart.js — carrito contra el AJAX Cart API de Shopify.
   ----------------------------------------------------------------------------
   NO hay un carrito propio en JS. No se guarda nada en localStorage. La única
   fuente de verdad es Shopify:
     POST /cart/add.js      agregar
     POST /cart/change.js   cambiar cantidad / quitar
     GET  /cart.js          leer
   El HTML del cajón se vuelve a pintar con la Section Rendering API, así los
   precios los formatea Shopify (moneda, separadores, impuestos) y nunca los
   calcula este archivo.

   Sin JavaScript la tienda igual vende: cada botón "Agregar" es un <form>
   real que hace POST a /cart/add y cae en la página /cart.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.Compraloy || (window.Compraloy = {});
  var rutas = CFG.rutas || {};
  var SECCION = 'carrito';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------- Abrir / cerrar */
  function cajon() { return $('#carrito'); }
  function velo() { return $('#velo'); }

  function abrir() {
    var c = cajon();
    if (!c) return;
    c.classList.add('abierto');
    c.setAttribute('aria-hidden', 'false');
    if (velo()) velo().classList.add('abierto');
    document.body.style.overflow = 'hidden';
    var cerrarBtn = $('#cerrar-carrito', c);
    if (cerrarBtn) cerrarBtn.focus();
  }

  function cerrar() {
    var c = cajon();
    if (!c) return;
    c.classList.remove('abierto');
    c.setAttribute('aria-hidden', 'true');
    if (velo()) velo().classList.remove('abierto');
    document.body.style.overflow = '';
  }

  /* ---------------------------------------------- Repintar desde el servidor */
  function aplicarSeccion(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('#shopify-section-' + SECCION);
    var actual = document.querySelector('#shopify-section-' + SECCION);
    if (!nuevo || !actual) return;
    var abierta = cajon() && cajon().classList.contains('abierto');
    actual.innerHTML = nuevo.innerHTML;
    if (abierta && cajon()) {
      cajon().classList.add('abierto');
      cajon().setAttribute('aria-hidden', 'false');
    }
    sincronizarContador();
    enganchar();
  }

  /* Cuantas unidades habia en la vuelta anterior. Empieza en null a proposito:
     en la PRIMERA sincronizacion (al cargar la pagina) no se salta nada — un
     globo saltando solo porque abriste la pagina no informa de nada. */
  var unidadesPrevias = null;

  function sincronizarContador() {
    var c = cajon();
    if (!c) return;
    var n = parseInt(c.getAttribute('data-cantidad') || '0', 10);
    if (isNaN(n)) return;

    /* Solo salta cuando SUBE. Al quitar una unidad el numero tambien cambia,
       y celebrar eso seria decir lo contrario de lo que paso. */
    var subio = unidadesPrevias !== null && n > unidadesPrevias;
    unidadesPrevias = n;

    $$('[data-carrito-contador]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
      if (!subio) return;
      el.classList.remove('salta');
      /* Forzar el reflow para que la animacion vuelva a arrancar aunque se
         agreguen dos productos seguidos. Sin esto, el segundo no se mueve. */
      void el.offsetWidth;
      el.classList.add('salta');
      setTimeout(function () { el.classList.remove('salta'); }, 300);
    });
  }

  function refrescar() {
    if (!rutas.carrito) return Promise.resolve();
    return fetch(rutas.carrito + '?sections=' + SECCION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d[SECCION]) aplicarSeccion(d[SECCION]); })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------ Errores */
  function mostrarError(form, texto) {
    var caja = form.querySelector('[data-error]');
    if (!caja) {
      caja = document.createElement('p');
      caja.className = 'form-error';
      caja.setAttribute('data-error', '');
      form.appendChild(caja);
    }
    caja.textContent = texto;
  }
  function limpiarError(form) {
    var caja = form.querySelector('[data-error]');
    if (caja) caja.textContent = '';
  }

  /* ----------------------------------------------------------------- Agregar */
  function agregar(form) {
    if (!rutas.carritoAgregar) return; // sin rutas, que haga el POST normal
    var boton = form.querySelector('[type="submit"]');
    var etiqueta = boton ? boton.textContent : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Agregando…'; }
    limpiarError(form);

    var datos = new FormData(form);
    datos.append('sections', SECCION);

    fetch(rutas.carritoAgregar, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Shopify manda `description` cuando no hay stock suficiente
          mostrarError(form, res.d.description || res.d.message || 'No pudimos agregarlo. Intenta de nuevo.');
          return;
        }
        if (res.d.sections && res.d.sections[SECCION]) {
          aplicarSeccion(res.d.sections[SECCION]);
        } else {
          return refrescar();
        }
        abrir();
      })
      .catch(function () {
        mostrarError(form, 'Se cayó la conexión. Intenta de nuevo.');
      })
      .then(function () {
        if (boton) { boton.disabled = false; boton.textContent = etiqueta; }
      });
  }

  /* ------------------------------------------------------- Cambiar cantidad */
  function cambiar(linea, cantidad) {
    if (!rutas.carritoCambiar) return;
    var c = cajon();
    if (c) c.setAttribute('aria-busy', 'true');
    fetch(rutas.carritoCambiar, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad, sections: SECCION })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && d.sections && d.sections[SECCION]) aplicarSeccion(d.sections[SECCION]);
        else refrescar();
      })
      .catch(function () { refrescar(); })
      .then(function () { if (cajon()) cajon().removeAttribute('aria-busy'); });
  }

  /* --------------------------------------------------------------- Enganches */
  function enganchar() {
    $$('[data-abrir-carrito]').forEach(function (btn) {
      if (btn.dataset.listo) return;
      btn.dataset.listo = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); abrir(); });
    });

    $$('#cerrar-carrito, #velo').forEach(function (el) {
      if (el.dataset.listo) return;
      el.dataset.listo = '1';
      el.addEventListener('click', cerrar);
    });

    $$('form[data-agregar-carrito]').forEach(function (form) {
      if (form.dataset.listo) return;
      form.dataset.listo = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        agregar(form);
      });
    });

    $$('[data-linea-cambiar]').forEach(function (btn) {
      if (btn.dataset.listo) return;
      btn.dataset.listo = '1';
      btn.addEventListener('click', function () {
        var linea = parseInt(btn.getAttribute('data-linea'), 10);
        var cant = parseInt(btn.getAttribute('data-cantidad-nueva'), 10);
        if (isNaN(linea) || isNaN(cant) || cant < 0) return;
        cambiar(linea, cant);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  function iniciar() {
    enganchar();
    sincronizarContador();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();
